export function NewBadgeIcon() {
  return (
    <svg width="32" height="16" viewBox="0 0 32 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="16" rx="2" fill="#E2FCFE" />
      <path
        d="M10.8333 4.72727V12H9.82477L6.12804 6.66619H6.06056V12H4.96326V4.72727H5.97889L9.67917 10.0682H9.74664V4.72727H10.8333ZM12.634 12V4.72727H17.1936V5.67188H13.7313V7.88778H16.9557V8.82884H13.7313V11.0554H17.2362V12H12.634ZM20.2834 12L18.2663 4.72727H19.4204L20.8373 10.3594H20.9048L22.3785 4.72727H23.522L24.9957 10.3629H25.0632L26.4765 4.72727H27.6342L25.6136 12H24.5092L22.9787 6.55256H22.9219L21.3913 12H20.2834Z"
        fill="#0E7490"
      />
    </svg>
  );
}
